import _ from 'lodash';
import keyMirror from 'keymirror';

const TableViewConstants = keyMirror({
  AERIAL: null,
  LIST: null,
});

export const TableViewOptions = _.map(TableViewConstants, (tableView: string) => {
  return {
    key: tableView,
    label: _.capitalize(tableView),
    value: tableView,
  };
});

export default TableViewConstants;
